module.exports = __webpack_public_path__ + "img/SK.c9e87470.png";